import { apiSlice } from '../../api';
import type { GetDashboardDTO, GetDashboardResult } from './types';

export const adminDashboardEndpoints = apiSlice.injectEndpoints({
  endpoints: (build) => {
    return {
      getDashboard: build.query<GetDashboardResult, GetDashboardDTO>({
        query: () => ({
          url: '/admin/v1/dashboard',
          method: 'get',
        }),
      }),
    };
  },
});

export const { useGetDashboardQuery, useLazyGetDashboardQuery } = adminDashboardEndpoints;

export type AdminDashboardController = typeof adminDashboardEndpoints;
